import React from 'react';

const TestPage = () => (
  <div>
  </div>
);

export default TestPage



// WEBPACK FOOTER //
// ./app/containers/TestPage/index.js